module.exports = __webpack_public_path__ + "static/media/jobImg1.f1afc79b.jpg";